import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, isRef as _isRef, normalizeStyle as _normalizeStyle, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

import { ref, watch, nextTick, onMounted } from 'vue';
// import { useRoute } from "vue-router";
import { Modal, Space, ConfigProvider } from 'ant-design-vue';
import { CloseOutlined, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons-vue';
import { useVModel } from '@vueuse/core';
import { throttle } from 'lodash-es';
import { theme } from 'ant-design-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  props: {
  afterClose: {
    type: Function
  },
  cancelButtonProps: {
    type: Object
  },
  cancelText: {
    type: String
  },
  centered: Boolean,
  closable: {
    type: Boolean,
    default: true
  },
  confirmLoading: Boolean,
  destroyOnClose: {
    type: Boolean,
    default: false
  },
  forceRender: {
    type: Boolean,
    default: false
  },
  keyboard: {
    type: Boolean,
    default: true
  },
  mask: {
    type: Boolean,
    default: true
  },
  maskClosable: {
    type: Boolean,
    default: false
  },
  maskStyle: Object,
  bodyStyle: Object,
  okButtonProps: Object,
  okText: String,
  okType: String,
  open: Boolean,
  wrapClassName: String,
  zIndex: Number,
  footer: {

  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
  width: {
    type: [Number, String],
    default: 520,
  },
  dlgStyle: {
    type: Object
  },
  containerId: {
    type: String,
    default: ""
  },
  title: {
    type: String,
  },
  themeConfig: {
    type: Object,
  }
},
  emits: ['update:open', 'update:fullscreen', 'ok', 'cancel'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;

const visibleModel = useVModel(props, 'open');

const fullscreenModel = ref(props.fullscreen);
const innerWidth = ref('');

const cursorStyle = {
  top: 'n-resize',
  left: 'w-resize',
  right: 'e-resize',
  bottom: 's-resize',
  topLeft: 'nw-resize',
  topright: 'ne-resize',
  bottomLeft: 'sw-resize',
  bottomRight: 'se-resize',
  auto: 'auto',
} as const;

// 是否已经初始化过了
let inited = false;
const modalWrapRef = ref<HTMLDivElement>();

const getContainer = function () {
  const targetContainer = document.getElementById(props.containerId)
  if (props.containerId == "") {
    // console.warn("挂载容器是：body")
    return document.body
  } else {
    if (targetContainer) {
      // console.warn("挂载容器是：" + props.containerId)
      return targetContainer
    } else {
      // console.warn("挂载容器是：body")
      return document.body
    }
  }
}

const localThemeConfig = ref(props.themeConfig)
// computed(() => {
//   debugger
//   if (typeof props.themeConfig === 'object') {
//     //如果外部有配置，则使用外部主题
//     return props.themeConfig
//   } else {
//     //如果外部无变化，则从缓存中获取
//     const localStorageThemeConfig = localStorage.getItem('themeConfig')
//     if (localStorageThemeConfig) {
//       const themeConfig = JSON.parse(localStorageThemeConfig)
//       themeConfig.algorithm = themeConfig.algorithm ? themeConfig.darkAlgorithm : theme.defaultAlgorithm
//       return themeConfig
//     }
//     return {}
//   }
// })

// 添加对 props.themeConfig 变化的监听
watch(() => props.themeConfig, () => {
  getModalThem()
}, { deep: true })

const getModalThem = function () {
  if (props.themeConfig && typeof props.themeConfig === 'object') {
    //如果外部有配置，则使用外部主题
    localThemeConfig.value = props.themeConfig
  } else {
    //如果外部无变化，则从缓存中获取
    const localStorageThemeConfig = localStorage.getItem('themeConfig')
    if (localStorageThemeConfig) {
      const themeConfig = JSON.parse(localStorageThemeConfig)
      themeConfig.algorithm = themeConfig.algorithm ? theme.darkAlgorithm : theme.defaultAlgorithm
      localThemeConfig.value = themeConfig
    }
  }
}

const handleOK = () => {
  emit('ok')
}

const handleCancel = () => {
  emit('cancel')
}


const closeModal = () => {
  visibleModel.value = false;
  emit('cancel');
};

// 居中弹窗
const centerModal = async () => {
  await nextTick();
  const modalEl = modalWrapRef.value?.querySelector<HTMLDivElement>('.ant-modal');

  if (modalEl && modalEl.getBoundingClientRect().left < 1) {
    modalEl.style.left = (document.documentElement.clientWidth - modalEl.offsetWidth) / 2 + 'px';
  }
};

const restore = async () => {
  fullscreenModel.value = false;
  centerModal();
};

const registerDragTitle = (dragEl: HTMLDivElement, handleEl: HTMLDivElement) => {
  handleEl.style.cursor = 'move';
  handleEl.onmousedown = throttle((e: MouseEvent) => {
    if (fullscreenModel.value) return;
    document.body.style.userSelect = 'none';
    const disX = e.clientX - dragEl.getBoundingClientRect().left;
    const disY = e.clientY - dragEl.getBoundingClientRect().top;
    const mousemove = (event: MouseEvent) => {
      if (fullscreenModel.value) return;
      let iL = event.clientX - disX;
      let iT = event.clientY - disY;
      const maxL = document.documentElement.clientWidth - dragEl.offsetWidth;
      const maxT = document.documentElement.clientHeight - dragEl.offsetHeight;

      iL <= 0 && (iL = 0);
      iT <= 0 && (iT = 0);
      iL >= maxL && (iL = maxL);
      iT >= maxT && (iT = maxT);

      dragEl.style.left = iL + 'px';
      dragEl.style.top = iT + 'px';
    };
    const mouseup = () => {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
      document.body.style.userSelect = 'auto';
    };

    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', mouseup);
  }, 20);
};

const initDrag = async () => {
  /* eslint-disable*/
  await nextTick();
  const modalWrapRefEl = modalWrapRef.value!;
  const modalWrapEl =
    modalWrapRefEl.querySelector<HTMLDivElement>(".ant-modal-wrap");
  const modalEl = modalWrapRefEl.querySelector<HTMLDivElement>(".ant-modal");
  if (modalWrapEl && modalEl) {
    centerModal();
    const headerEl =
      modalEl.querySelector<HTMLDivElement>(".ant-modal-header");
    headerEl && registerDragTitle(modalEl, headerEl);

    modalWrapEl.onmousemove = throttle((event: MouseEvent) => {
      if (fullscreenModel.value) return;
      const left = event.clientX - modalEl.offsetLeft;
      const top = event.clientY - modalEl.offsetTop;
      const right =
        event.clientX - modalEl.offsetWidth - modalEl.offsetLeft;
      const bottom =
        event.clientY - modalEl.offsetHeight - modalEl.offsetTop;
      const isLeft = left <= 0 && left > -8;
      const isTop = top < 5 && top > -8;
      const isRight = right >= 0 && right < 8;
      const isBottom = bottom > -5 && bottom < 8;
      // 向左
      if (isLeft && top > 5 && bottom < -5) {
        modalWrapEl.style.cursor = cursorStyle.left;
        // 向上
      } else if (isTop && left > 5 && right < -5) {
        modalWrapEl.style.cursor = cursorStyle.top;
        // 向右
      } else if (isRight && top > 5 && bottom < -5) {
        modalWrapEl.style.cursor = cursorStyle.right;
        // 向下
      } else if (isBottom && left > 5 && right < -5) {
        modalWrapEl.style.cursor = cursorStyle.bottom;
        // 左上角
      } else if (left > -8 && left <= 5 && top <= 5 && top > -8) {
        modalWrapEl.style.cursor = cursorStyle.topLeft;
        // 左下角
      } else if (left > -8 && left <= 5 && bottom <= 5 && bottom > -8) {
        modalWrapEl.style.cursor = cursorStyle.bottomLeft;
        // 右上角
      } else if (right < 8 && right >= -5 && top <= 5 && top > -8) {
        modalWrapEl.style.cursor = cursorStyle.topright;
        // 右下角
      } else if (right < 8 && right >= -5 && bottom <= 5 && bottom > -8) {
        modalWrapEl.style.cursor = cursorStyle.bottomRight;
      } else {
        modalWrapEl.style.cursor = cursorStyle.auto;
      }
    }, 20);
    modalWrapEl.onmousedown = (e: MouseEvent) => {
      if (fullscreenModel.value) return;
      const iParentTop = modalEl.getBoundingClientRect().top;
      const iParentLeft = modalEl.getBoundingClientRect().left;
      const disX = e.clientX - iParentLeft;
      const disY = e.clientY - iParentTop;
      const iParentWidth = modalEl.offsetWidth;
      const iParentHeight = modalEl.offsetHeight;

      const cursor = modalWrapEl.style.cursor;

      const mousemove = throttle((event: MouseEvent) => {
        if (fullscreenModel.value) return;
        if (cursor !== cursorStyle.auto) {
          document.body.style.userSelect = "none";
        }
        // 向左边拖拽
        if (cursor === cursorStyle.left) {
          modalEl.style.left = event.clientX - disX + "px";
          modalEl.style.width =
            iParentWidth + iParentLeft - event.clientX + "px";
          // 向上边拖拽
        } else if (cursor === cursorStyle.top) {
          modalEl.style.top = event.clientY - disY + "px";
          modalEl.style.height =
            iParentHeight + iParentTop - event.clientY + "px";
          // 向右边拖拽
        } else if (cursor === cursorStyle.right) {
          modalEl.style.width = event.clientX - iParentLeft + "px";
          // 向下拖拽
        } else if (cursor === cursorStyle.bottom) {
          modalEl.style.height = event.clientY - iParentTop + "px";
          // 左上角拖拽
        } else if (cursor === cursorStyle.topLeft) {
          modalEl.style.left = event.clientX - disX + "px";
          modalEl.style.top = event.clientY - disY + "px";
          modalEl.style.height =
            iParentHeight + iParentTop - event.clientY + "px";
          modalEl.style.width =
            iParentWidth + iParentLeft - event.clientX + "px";
          // 右上角拖拽
        } else if (cursor === cursorStyle.topright) {
          modalEl.style.top = event.clientY - disY + "px";
          modalEl.style.width = event.clientX - iParentLeft + "px";
          modalEl.style.height =
            iParentHeight + iParentTop - event.clientY + "px";
          // 左下角拖拽
        } else if (cursor === cursorStyle.bottomLeft) {
          modalEl.style.left = event.clientX - disX + "px";
          modalEl.style.width =
            iParentWidth + iParentLeft - event.clientX + "px";
          modalEl.style.height = event.clientY - iParentTop + "px";
          // 右下角拖拽
        } else if (cursor === cursorStyle.bottomRight) {
          modalEl.style.width = event.clientX - iParentLeft + "px";
          modalEl.style.height = event.clientY - iParentTop + "px";
        }
        innerWidth.value = modalEl.style.width;
      }, 20);

      const mouseup = () => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);
        document.body.style.userSelect = "auto";
        modalWrapEl.style.cursor = cursorStyle.auto;
      };

      document.addEventListener("mousemove", mousemove);
      document.addEventListener("mouseup", mouseup);
    };
  }
  inited = true;
};

watch(visibleModel, async (val) => {
  if ((val && Object.is(inited, false)) || props.destroyOnClose) {
    initDrag();
  }
  getModalThem()
});

watch(() => fullscreenModel.value, (val) => {
  emit("update:fullscreen", val)
})

onMounted(() => {
  getModalThem()
})

// watch(() => route.fullPath, closeModal);

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_Teleport, {
    to: getContainer()
  }, [
    _createElementVNode("div", {
      ref_key: "modalWrapRef",
      ref: modalWrapRef,
      class: _normalizeClass(["custom-modal", { fullscreen: fullscreenModel.value }])
    }, [
      _createVNode(_unref(ConfigProvider), { theme: localThemeConfig.value }, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal), {
            getContainer: () => modalWrapRef.value,
            open: _unref(visibleModel),
            "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_isRef(visibleModel) ? (visibleModel).value = $event : null)),
            maskClosable: false,
            width: innerWidth.value || __props.width,
            afterClose: __props.afterClose,
            cancelButtonProps: __props.cancelButtonProps,
            cancelText: __props.cancelText,
            centered: __props.centered,
            closable: __props.closable,
            confirmLoading: __props.confirmLoading,
            destroyOnClose: __props.destroyOnClose,
            forceRender: __props.forceRender,
            keyboard: __props.keyboard,
            mask: __props.mask,
            maskStyle: __props.maskStyle,
            okButtonProps: __props.okButtonProps,
            okText: __props.okText,
            okType: __props.okType,
            wrapClassName: __props.wrapClassName,
            zIndex: __props.zIndex,
            onOk: handleOK,
            onCancel: handleCancel,
            bodyStyle: __props.bodyStyle,
            style: _normalizeStyle(__props.dlgStyle),
            footer: __props.footer
          }, _createSlots({
            title: _withCtx(() => [
              _createVNode(_component_a_row, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { style: {"width":"calc(100% - 27px)"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.title || '标题'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    style: {"width":"22px","margin-top":"-12px","text-align":"right","margin-right":"2px"},
                    class: "full-screen-operate"
                  }, {
                    default: _withCtx(() => [
                      (!fullscreenModel.value)
                        ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (fullscreenModel.value = true)),
                            style: {"color":"rgba(0, 0, 0, 0.75)"}
                          }))
                        : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), {
                            key: 1,
                            onClick: restore
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            closeIcon: _withCtx(() => [
              _renderSlot(_ctx.$slots, "closeIcon", {}, () => [
                _createVNode(_unref(Space), {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  class: "ant-modal-operate"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CloseOutlined), { onClick: closeModal })
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 2
          }, [
            (_ctx.$slots.footer)
              ? {
                  name: "footer",
                  fn: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "footer")
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["getContainer", "open", "width", "afterClose", "cancelButtonProps", "cancelText", "centered", "closable", "confirmLoading", "destroyOnClose", "forceRender", "keyboard", "mask", "maskStyle", "okButtonProps", "okText", "okType", "wrapClassName", "zIndex", "bodyStyle", "style", "footer"])
        ]),
        _: 3
      }, 8, ["theme"])
    ], 2)
  ], 8, ["to"]))
}
}

})